import { render, staticRenderFns } from "./SlrcL_Search.vue?vue&type=template&id=770cc983"
import script from "./SlrcL_Search.vue?vue&type=script&lang=js"
export * from "./SlrcL_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports